import BaseAPI from "../api";

const path: string = "fiscalYears";

export type cloneFiscalYear = {
  fiscalYear: string;
  fiscalYearStatus: string;
};

export interface createFiscalYearType {
  fiscalYear: string;
  fiscalYearStatus: string;
}
export interface getFiscalYear {
  keyword?: string;
  page?: number;
  limit?: number;
}
export interface updateFiscalYear {
  fiscalYear?: string;
  fiscalYearStatus?: string;
}
export type progressIndicator = {
  min: number;
  max: number;
  result: number;
  remark: string;
};
export interface updateProgressIndicator {
  details: progressIndicator[];
}

export interface updateNotificationConfig {
  notifyProgressAt: number;
  notifyStatusAt: number;
}

export class FiscalYearApi extends BaseAPI {
  public static createFiscalYear(props: createFiscalYearType): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res);
  }
  public static getFiscalYear(props: getFiscalYear): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  public static updateFiscalYear(
    idFiscalYear: number,
    props: updateFiscalYear
  ): Promise<any> {
    return this.api.patch(`${path}/${idFiscalYear}`, props).then((res) => res);
  }
  public static getDetailFiscalYear(idFiscalYear: number): Promise<any> {
    return this.api.get(`${path}/${idFiscalYear}`).then((res) => res);
  }

  // progress indicator
  public static getProgressIndicator(idFiscalYear: number): Promise<any> {
    return this.api
      .get(`${path}/${idFiscalYear}/progressindicator`)
      .then((res) => res);
  }
  public static updateProgressIndicator(
    idFiscalYear: number,
    props: updateProgressIndicator
  ): Promise<any> {
    return this.api
      .patch(`${path}/${idFiscalYear}/progressindicator`, props)
      .then((res) => res);
  }

  // notification config
  public static updateNotificationConfig(
    idFiscalYear: number,
    props: updateNotificationConfig
  ): Promise<any> {
    return this.api
      .patch(`${path}/${idFiscalYear}/notificationconfig`, props)
      .then((res) => res);
  }

  public static getNotificationConfig(idFiscalYear: number): Promise<any> {
    return this.api
      .get(`${path}/${idFiscalYear}/notificationconfig`)
      .then((res) => res);
  }
  static clone(idFiscalYear: number, body: cloneFiscalYear): Promise<any> {
    return this.api.post(`${path}/${idFiscalYear}/clone`);
  }
}
